export default "__VITE_ASSET__b1786ab8__"